export class RepliesUIRequest {
    constructor() {
        this.time = 0;
        this.count = 20;
        this.before = true;
        this.sortAsc = false;
    }
}
